import { render } from "./InboxLoader.vue?vue&type=template&id=23de24ba"
import script from "./InboxLoader.vue?vue&type=script&lang=js"
export * from "./InboxLoader.vue?vue&type=script&lang=js"

import "./InboxLoader.vue?vue&type=style&index=0&id=23de24ba&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__